import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Link } from 'react-router-dom';
import { useMutation } from 'react-query';
import PhoneNumber from '../phone_numbers/PhoneNumber.js';

export default function Create() {
  let history = useHistory();
  const mutation = useMutation(newNumber => PhoneNumber.create(newNumber), {
    onSuccess: (data) => {
      history.push('/phone_numbers');
    }
  })

  const [areaCode, setAreaCode] = useState('');

  function save() {
    mutation.mutate({
      area_code: areaCode
    })
  }

  return (
    <Container>
      {mutation.isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {mutation.error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {mutation.error.message}
            </Alert>
          </Col>
        </Row>
      )}
      <Row className='pt-3'>
        <Col>
          <Form>
            <Row>
              <Col>
                <FloatingLabel label="Area Code" className="mb-3">
                  <Form.Control type="text" onChange={e => setAreaCode(e.target.value)} />
                </FloatingLabel>
              </Col>
            </Row>

            <Button variant="primary" className="mr-3" onClick={save}>
              Save
            </Button>

            <Link to={"/phone_numbers"} className='btn'>
              Back to list
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}